import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Table from '@common/Table'
import columns from './column'
import indexStore from '../../store'

@observer
export default class extends Component {
  render() {
    const { store } = this.props

    return (
      <Table
        rowKey="example_id"
        selectabled
        store={store}
        columns={columns}
        bordered={false}
        rowSelection={{
          getCheckboxProps: record => {
            return {
              disabled:
                indexStore.useExample.indexOf(record.example_id + '') > -1 ||
                record?.isServiceRelated == 1
            }
          },
          onChange: store.$onSelectChange,
          selectedRowKeys: store.$selectedRowKeys
        }}
      />
    )
  }
}
